import { AnyAction, combineReducers } from "redux";
import { authSlice } from "./auth/authSlice";
import { authSlice as usersSlice } from "./users/usersSlice";

const appReducer = combineReducers({
  auth: authSlice.reducer,
  users: usersSlice.reducer,
});

const rootReducer = (state: any, action: AnyAction) => {
  return appReducer(state, action);
};

export default rootReducer;
